// CoordinateService.js
import { transform } from 'ol/proj';
import { MAP_PROJECTION_CODE, REGION_EXTENTS } from './Config';

const WGS84 = 'EPSG:4326';

export const CoordinateService = {
    // دالة آمنة للتحويل إلى الإحداثيات العالمية
    toWGS84(coords, sourceProjCode) {
        try {
            if (!sourceProjCode) return null;
            return transform(coords, sourceProjCode, WGS84);
        } catch (err) {
            console.error("Coordinate transformation error:", err);
            return null;
        }
    },

    // دالة التحويل من العالمية إلى المحلية
    fromWGS84(lon, lat, targetProjCode = MAP_PROJECTION_CODE) {
        try {
            return transform([lon, lat], WGS84, targetProjCode);
        } catch (err) {
            console.error("Coordinate transformation error:", err);
            return null;
        }
    },

    // تنسيق وعرض الإحداثيات المحلية
    formatLocal(x, y) {
        return `${x.toFixed(2)} X, ${y.toFixed(2)} Y`;
    },

    // التحقق من وقوع الإحداثيات ضمن حدود الضفة وغزة (إحداثيات محلية)
    validateInExtent(x, y) {
        const gaza = REGION_EXTENTS.GAZA;
        const wb = REGION_EXTENTS.WEST_BANK;

        const inGaza = (x >= gaza[0] && x <= gaza[2] && y >= gaza[1] && y <= gaza[3]);
        const inWB = (x >= wb[0] && x <= wb[2] && y >= wb[1] && y <= wb[3]);

        return {
            valid: inGaza || inWB,
            message: (inGaza || inWB) ? '' : 'الإحداثيات المحلية المدخلة خارج نطاق التغطية.'
        };
    },

    // التحقق من صحة إحداثيات WGS84 ووقوعها في فلسطين
    validateWGS84(lat, lon) {
        if (isNaN(lat) || isNaN(lon) || lat < -90 || lat > 90 || lon < -180 || lon > 180) {
            return { valid: false, message: 'يرجى إدخال قيم صحيحة لخطوط العرض والطول.' };
        }

        // تحويل للتحقق من النطاق الجغرافي
        const local = this.fromWGS84(lon, lat);
        if (!local) return { valid: false, message: 'فشل في تحويل الإحداثيات.' };

        const extentValid = this.validateInExtent(local[0], local[1]);
        if (!extentValid.valid) {
            return { valid: false, message: 'الإحداثيات العالمية المدخلة خارج نطاق فلسطين.' };
        }

        return { valid: true, localCoords: local };
    }
};
